import React from 'react';
import PropTypes from 'prop-types';
import { UserShape } from '../shapes';
import { Link } from 'react-router-dom';
import pluralize from 'pluralize';

export default class PeopleSearchSuggestedPerson extends React.Component {

  static propTypes = {
    user: UserShape,
    index: PropTypes.number,
    currentIndex: PropTypes.number,
    downshiftItemProps: PropTypes.func
  }

  render() {
    return(
      <div
        {...this.props.downshiftItemProps({
          key: this.props.index,
          index: this.props.index,
          item: this.userDisplayName(),
          className: this.suggestedPersonClassName(),
        })}
      >
        <Link to={ `/people/${ this.props.user.get('slug') }`} >
          <b>{ this.userDisplayName() }</b>
          <div>
            <span className='item-meta'>{ this.props.user.get('headline') }</span>
            <span className='dot-spacer'></span>
            <span className='item-meta'>{ pluralize('tack', this.props.user.get('tacksCount'), true) }</span>
          </div>
        </Link>
      </div>
    );
  }

  userDisplayName() {
    return this.props.user.get('name') || this.props.user.get('slug');
  }

  suggestedPersonClassName() {
    if (this.props.index == this.props.currentIndex) {
      return 'highlighted suggested-search-item person-item';
    } else {
      return 'suggested-search-item person-item';
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/people_search_suggested_person.jsx